<template>
  <div class="pageContainer">
    <div class="infoList">
      <div
        class="listItem"
        v-for="(item, index) in applyInfo"
        :key="index"
        v-if="applyInfo.length"
      >
        <div class="infoHeader">{{ item.name }}</div>
        <div class="infoBody">
          <div class="bodyLine">
            <div class="lineName">使用目的</div>
            <div class="lineContent">{{ item.dest }}</div>
          </div>
          <div class="dividerLine"></div>
          <div class="bodyLine">
            <div class="lineName">使用场景</div>
            <div class="lineContent">{{ item.timing }}</div>
          </div>
          <div class="dividerLine"></div>
          <div class="bodyLine">
            <div class="lineName">收集情况</div>
            <div class="lineContent" v-if="item.apiKey">
              <span>{{
                apiInfo[item.apiKey] === null ||
                apiInfo[item.apiKey] === undefined ||
                apiInfo[item.apiKey] === "未收集"
                  ? "未收集"
                  : "已收集"
              }}</span>
            </div>
            <div class="lineContent" v-else>
              <span v-if="typeof item.isCollected === 'boolean'">{{
                item.isCollected ? "已收集" : "未收集"
              }}</span>
              <span v-else>{{ item.isCollected }}</span>
            </div>
          </div>
          <div class="dividerLine"></div>
          <div class="bodyLine">
            <div class="lineName">信息内容</div>
            <div
              :class="{
                lineContent: true,
                lineContentJump:
                  item.jumpPage &&
                  (item.apiKey ? apiInfo[item.apiKey] !== null : true),
              }"
              @click="jumpHandler(item)"
            >
              <span v-if="item.apiKey">
                <span
                  v-if="
                    apiInfo[item.apiKey] === null ||
                      apiInfo[item.apiKey] === undefined ||
                      apiInfo[item.apiKey] === '未收集'
                  "
                  >{{ item.apiKey === "order" ? "无订单记录" : "无" }}</span
                >
                <span v-else>{{ item.value }}</span>
              </span>
              <span v-else>{{ item.value }}</span>
            </div>
          </div>
        </div>
        <div v-if="applyInfo.length === 0">暂无信息</div>
      </div>
    </div>
  </div>
</template>

<script>
import applyInfoBase from "./applyInfo";
import { mergePrintmasterApplyInfoRows } from "@/constants/printmasterUrlAuth";

export default {
  computed: {
    platform() {
      return this.$store.state.platform;
    },
    apiInfo() {
      if (
        ["Mrin", "Printmaster", "LabelMaster", "XBManager", "Phocol"].indexOf(
          this.platform
        ) !== -1
      ) {
        return this.$store.state[this.platform];
      } else {
        return {};
      }
    },
    applyInfo() {
      if (
        ["Mrin", "Printmaster", "LabelMaster", "XBManager", "Phocol"].indexOf(
          this.platform
        ) === -1
      ) {
        return [];
      }
      const base = applyInfoBase[this.platform];
      if (!base) return [];
      if (this.platform !== "Printmaster" || !this.$store.state.printmasterAuth) {
        return base;
      }
      return mergePrintmasterApplyInfoRows(base, this.$store.state.printmasterAuth);
    },
  },
  methods: {
    jumpHandler(item) {
      if (item.jumpPage) {
        this.jumpPage(item.jumpPage);
      }
    },
    jumpPage(msg) {
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.indexOf("iphone") >= 0) {
        window.webkit.messageHandlers.jumpPage.postMessage(msg);
      } else if (ua.indexOf("android") >= 0) {
        Android.jumpPage(msg);
      } else {
        if (Android && Android.jumpPage) {
          Android.jumpPage(msg);
        } else {
          window.webkit.messageHandlers.jumpPage.postMessage(msg);
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.pageContainer
  padding 0 .24rem .16rem
  box-sizing border-box
  .infoList
    .listItem
      margin-top .32rem
      .infoHeader
        text-align left
        font-size .28rem
        font-weight bold
        color #2F3541
        line-height .44rem
      .infoBody
        width 100%
        background #F3F4F5
        border-radius .16rem
        margin .16rem 0
        padding 0 .24rem
        box-sizing border-box
        .bodyLine
          display flex
          padding .24rem 0
          .lineName
            width 1.92rem
            font-size .24rem
            color #2F3541
            text-align left
            flex-shrink 0
            line-height .36rem
          .lineContent
            flex-grow 1
            font-size .24rem
            color #878D99
            text-align left
            line-height .36rem
            &Jump
              color #3D82F3
        .dividerLine
          width 100%
          height .01rem
          background #D9D9D9
          content "\00a0"
</style>
